import React from "react"
import {
  StyledImpactApproachTitle,
  StyledImpactApproachContent,
} from "../Typography"
import { Container } from "react-grid-system"
import { Fade } from "react-reveal"
import GreyCircle from "../GreyCircle"
import DarkGreyCircle from "../DarkGreyCircle"
import DarkBlueCircle from "../DarkBlueCircle"
import LightBlueCircle from "../LightBlueCircle"
import { breakpoint } from "../../utils/breakpoint"
import styled from "styled-components"

const StyledMainContentWrapper = styled.div`
  min-height: 440px;

  ${breakpoint.sm} {
    min-height: 340px;
  }

  ${breakpoint.md} {
    min-height: 315px;
  }
`

const MobileVersion = () => {
  return (
    <>
      <Container fluid xs sm md>
        <div style={{ width: "100%" }}>
          <Fade ssrReveal left>
            <div style={{ marginBottom: "3px" }}>
              <StyledImpactApproachTitle style={{ color: "#0F6497" }}>
                initial screen
              </StyledImpactApproachTitle>
            </div>
            <div
              style={{
                borderBottom: "3px solid #0F6497",
                marginRight: "4.5px",
                marginBottom: "-8.5px",
              }}
            ></div>
          </Fade>
        </div>
        <StyledMainContentWrapper
          style={{
            width: "100%",
            display: "flex",
            alignItems: "stretch",
          }}
        >
          <div
            style={{
              flex: "1 1 auto",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "stretch",
            }}
          >
            <div
              style={{
                flex: "0 1 100%",
                height: "calc(50% - 1.5px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <Fade ssrReveal left>
                  <div style={{ marginTop: "10.5px" }}>
                    <StyledImpactApproachContent style={{ color: "#0F6497" }}>
                      Screen each opportunity by developing an impact thesis and
                      evaluating the company’s intentionality and commitment to
                      impact.
                    </StyledImpactApproachContent>
                  </div>
                </Fade>
              </div>
              <div>
                <Fade ssrReveal left>
                  <StyledImpactApproachTitle style={{ color: "#1E93D1" }}>
                    impact analysis
                  </StyledImpactApproachTitle>
                </Fade>
              </div>
            </div>
            <Fade ssrReveal left>
              <div
                style={{
                  flex: "0 1 100%",
                  width: "100%",
                  height: "3px",
                  backgroundColor: "#1E93D1",
                }}
              ></div>
            </Fade>
            <div
              style={{
                flex: "0 1 100%",
                height: "calc(50% - 1.5px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <Fade ssrReveal left>
                  <div style={{ marginTop: "6.5px" }}>
                    <StyledImpactApproachContent style={{ color: "#1E93D1" }}>
                      Assess potential impact performance based on
                      multi-dimension weighted framework to ensure investments
                      meet internal impact requirements.
                    </StyledImpactApproachContent>
                  </div>
                </Fade>
              </div>
              <Fade ssrReveal left>
                <div style={{ marginBottom: "8px" }}>
                  <StyledImpactApproachTitle style={{ color: "#60686F" }}>
                    portfolio engagement
                  </StyledImpactApproachTitle>
                </div>
              </Fade>
            </div>
          </div>
          <div style={{ flex: "0 0 auto" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
              }}
            >
              <Fade ssrReveal right>
                <DarkBlueCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <LightBlueCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <GreyCircle />
                <DarkGreyCircle />
              </Fade>
            </div>
          </div>
        </StyledMainContentWrapper>
        <div style={{ width: "100%" }}>
          <Fade ssrReveal left>
            <div
              style={{
                borderBottom: "3px solid #60686F",
                marginRight: "4.5px",
                marginTop: "-8.5px",
              }}
            ></div>
          </Fade>
          <div style={{ marginTop: "8px" }}>
            <Fade ssrReveal left>
              <StyledImpactApproachContent style={{ color: "#60686F" }}>
                Monitor portfolio companies using a set of impact metrics and
                indicators to report their progress throughout the investment
                period.
              </StyledImpactApproachContent>
            </Fade>
          </div>
        </div>
      </Container>
    </>
  )
}

export default MobileVersion
